module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('app-raster-legend', {
    ref: "legend",
    staticClass: "app-raster-legend",
    staticStyle: {
      "position": "absolute",
      "bottom": "15px",
      "margin-left": "15px",
      "z-index": "1"
    },
    attrs: {
      "value": _vm.isActive && !_vm.isDynamicStyle,
      "layout": "vertical"
    }
  }), _vm._v(" "), _c('v-navigation-drawer', {
    ref: "nav",
    attrs: {
      "app": "",
      "disable-resize-watcher": "",
      "hide-overlay": "",
      "mobile-break-point": "0",
      "value": _vm.isActive,
      "width": "500"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('comparativas')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('disableControl')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": ("grey " + (_vm.$store.getters.isDarkTheme ? 'darken-4' : 'lighten-4')),
      "height": "64"
    }
  }, [_c('div', {
    staticClass: "container-buttons"
  }, [_c('v-tooltip', {
    staticStyle: {
      "align-self": "center"
    },
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": _vm.isLoading,
      "fab": "",
      "small": "",
      "color": _vm.isDynamicStyle ? 'red darken-2' : 'blue darken-1'
    },
    on: {
      "click": function($event) {
        _vm.isDynamicStyle = !_vm.isDynamicStyle
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("palette")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cambiar-estilo')))])], 1)], 1)])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "color": ("green " + (_vm.$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'))
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('opciones')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.collapsed ? 'add' : 'remove'))])], 1)], 1)], 1), _vm._v(" "), (_vm.collapsed && _vm.isDynamicStyle) ? _c('v-divider', {
    attrs: {
      "dark": _vm.$store.getters.isDarkTheme
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-slide-y-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "px-3 pb-3",
    attrs: {
      "color": _vm.$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-indicador', {
    attrs: {
      "disabled": _vm.disabledButtonsByDialogs
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-period', {
    attrs: {
      "disabled": _vm.disabledButtonsByDialogs
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2 pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-ortofotos', {
    attrs: {
      "map": _vm.map,
      "ortoLayer": _vm.LayerOrto,
      "disabled": _vm.disabledButtonsByDialogs
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2 pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('app-select-raster', {
    ref: "rasterselect",
    attrs: {
      "value": _vm.isActive,
      "disabled": _vm.disabledButtonsByDialogs
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$t('comparative.compare')))]), _vm._v(" "), _c('app-add-polygons', {
    ref: "addpolys",
    on: {
      "changed": _vm.onChangePolygons
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('app-raster-filter', {
    ref: "rasterfilter",
    attrs: {
      "rasterLayer": _vm.LayerRaster,
      "value": _vm.isDynamicStyle && _vm.isActive
    }
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "dark": _vm.$store.getters.isDarkTheme
    }
  }), _vm._v(" "), (_vm.$refs.addpolys && _vm.$refs.addpolys.polygons && _vm.$refs.addpolys.polygons.length && _vm.results) ? _c('v-tabs', {
    attrs: {
      "color": "primary",
      "dark": "",
      "slider-color": "blue"
    },
    model: {
      value: (_vm.activeColumn),
      callback: function($$v) {
        _vm.activeColumn = $$v
      },
      expression: "activeColumn"
    }
  }, [_vm._l((_vm.$refs.addpolys.numPolygons), function(p) {
    return (_vm.$refs.addpolys.polygons[p - 1] && _vm.results && _vm.results[p - 1]) ? _c('v-tab', {
      key: ("tab-" + p),
      attrs: {
        "ripple": ""
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$refs.addpolys.polygons[p - 1].getProperties().properties.name) + "\n      ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$refs.addpolys.numPolygons), function(p) {
    return (_vm.results[p - 1]) ? _c('v-tab-item', {
      key: ("tabitem-" + p)
    }, [_c('v-container', {
      attrs: {
        "grid-list-xs": "",
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "140",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('v-card-actions', [_c('v-btn', {
      staticStyle: {
        "margin": "0px auto"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('vector-polygon-icon', {
      staticStyle: {
        "font-size": "24px"
      }
    })], 1)], 1), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(_vm.formattedAreas[p - 1])
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('area-poligono')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "140",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('v-card-actions', [_c('v-btn', {
      staticStyle: {
        "margin": "0px auto"
      },
      attrs: {
        "icon": "",
        "ripple": false
      }
    }, [_c('v-icon', [_vm._v("people")])], 1)], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.populations[p - 1] || 0) + " hab.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('poblacion-afectada')))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "140",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('v-card-actions', [_c('v-btn', {
      staticStyle: {
        "margin": "0px auto"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('vector-polygon-icon', {
      staticStyle: {
        "font-size": "24px"
      }
    })], 1)], 1), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(_vm.temperatures[p - 1][0])
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(("comparative." + _vm.indicador + ".polygon"))))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "140",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('v-card-actions', [_c('v-btn', {
      staticStyle: {
        "margin": "0px auto"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('vector-polygon-icon', {
      staticStyle: {
        "font-size": "24px"
      }
    })], 1)], 1), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(_vm.temperatures[p - 1][1])
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(("comparative." + _vm.indicador + ".extent"))))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "140",
        "flat": "",
        "ripple": ""
      }
    }, [_c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('v-card-actions', [_c('v-btn', {
      staticStyle: {
        "margin": "0px auto"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('vector-polygon-icon', {
      staticStyle: {
        "font-size": "24px"
      }
    })], 1)], 1), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s((_vm.temperatures[p - 1][0] - _vm.temperatures[p - 1][1]).toFixed(2))
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(("comparative." + _vm.indicador + ".difference"))))])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6490a93c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/compare/Compare.vue
// module id = 1065
// module chunks = 1